import { components } from "@certn/api/generated-schemas/client-portal";

export function successFactorsEditIntegrationStableKey(
  detail: components["schemas"]["AtsIntegrationDetail"]
): string {
  const sf = detail.successfactors_integration;
  if (!sf) {
    return detail.id ?? "";
  }
  return [
    detail.id,
    detail.is_active,
    detail.report_url_type,
    sf.team_id,
    sf.company_id,
    sf.api_user,
    sf.success_factors_oauth_client_id,
    sf.success_factors_oauth_token_endpoint,
    sf.odata_base_url,
    sf.x509_certificate,
    sf.saml_private_key,
    sf.has_saml_private_key,
    sf.webhook_username,
    sf.webhook_url,
    sf.webhook_password,
  ].join("\u0000");
}
